module.exports = __webpack_public_path__ + "img/scan.2eb44dfd.png";